import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Sends the window back to the top when the route changes.
 *
 * React Router keeps the current scroll position across navigations, so
 * opening a link from halfway down a page would otherwise drop you into
 * the middle of the next one.
 *
 * Two things are deliberately left alone:
 *  - back/forward (POP), so returning to a page keeps your place
 *  - links with a hash, so in-page anchors still work
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (hash) return;
    if (navigationType === 'POP') return;

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash, navigationType]);

  return null;
}
